// Other
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { Link } from 'react-router-dom'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import AppPageHeader from '../../components/AppPageHeader'
import DashboardLayout from '../../layouts/DashboardLayout'
import { WorkPageWrapper } from './ManagementAssetWarehouseStylePage'
import ManagementAssetWarehouseTable from './ManagementAssetWarehouseTable'
// Ant design
import { FileExcelOutlined } from '@ant-design/icons'
import { Button, Menu, message, Modal, Upload } from 'antd'
// Component

// Other
import pickBy from 'lodash/pickBy'
import moment from 'moment'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import XLSX from 'xlsx'
import AccessControlAction from '../../components/AccessControlAction'
import {
  AddCircleOutlineIcon,
  FileDownloadOutlineIcon,
  FileSendOutlineIcon,
  Home2OutlineIcon,
} from '../../components/AppIcon'
import ManagementAssetWarehouseRequest from '../../requests/ManagementAssetWarehouseRequest'
import { exportAssetWarehouse } from './ExportManagementAssetWarehouseExcel'
import ManagementAssetWarehouseCreate from './ManagementAssetWarehouseCreate'
import ManagementAssetWarehousePageAdvanceFilterV2 from './ManagementAssetWarehousePageAdvanceFilterV2'
import ManagementAssetWarehousePreviewModal from './ManagementAssetWarehousePreviewModal'
import ManagementAssetWarehouseUpdate from './ManagementAssetWarehouseUpdate'
import ModalAssetPreView from './ModalAssetPreView'

const ManagementAssetWarehousePage = props => {
  const {
    managementAssetWarehouseStore,
    loadingAnimationStore,
    fileStore,
  } = props

  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [selectedTemplateId, setSelectedTemplateId] = useState(null)
  const [checkImportStore, setCheckImportStore] = useState(false)
  const [currentDate] = useState(moment(new Date()).format('MM-YYYY'))
  const [importVisible, setImportVisible] = useState(false)
  const [fileExcel, setFileExcel] = useState(null)
  const [preViewVisible, setPreViewVisible] = useState(false)
  const [dataExcel, setDataExcel] = useState(null)
  const [isVisiblePreviewModal, setIsVisiblePreviewModal] = useState(false)
  const [listDataPreview, setListDataPreview] = useState([])
  const [listDataCurrent, setListDataCurrent] = useState([])
  const [isLoadingCreate, setIsLoadingCreate] = useState(false)

  const { managementAssetTypes } = managementAssetWarehouseStore

  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const currentQueryString = useMemo(() => {
    return queryString.stringify(
      pickBy(
        {
          page: queryStringParse?.page || 0,
          size: queryStringParse?.size || 10,
          asset_type_id: queryStringParse?.asset_type_id || null,
          asset_name: queryStringParse?.asset_name || null,
          createdAt: queryStringParse?.createdAt || undefined,
        },
        v => v != null
      )
    )
  }, [queryStringParse])

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  useEffect(() => {
    if (fileExcel == null) return
    handleGetDataExcel()
  }, [fileExcel])

  const handleGetDataExcel = async () => {
    if (!fileExcel) {
      message.error('Bạn chưa chọn file Excel.')
      return
    }
    const fileExtension = fileExcel.name.split('.').pop()

    if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
      message.error('Định dạng file không đúng.')
      return
    }
    loadingAnimationStore.showSpinner(true)
    const formData = new FormData()
    formData.append('file', fileExcel)
    try {
      const response = await fileStore.sendDataAssetExcel(formData)
      setDataExcel(response)
      setPreViewVisible(true)
      loadingAnimationStore.showSpinner(false)
    } catch (error) {
      console.error('Error importing Excel:', error)
      message.error('Đã xảy ra lỗi khi import file Excel.')
      loadingAnimationStore.showSpinner(false)
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const exportBetRefundExcel = async () => {
    try {
      const result = await ManagementAssetWarehouseRequest.getManagementAssetWarehouseList(
        `page=0&size=999999`
      )
      await exportAssetWarehouse(result?.data?.data)
    } catch (error) {
      console.log(error)
      message.error('Đã xảy ra lỗi khi export file Excel.')
    }
  }

  const handleOpenUpdateModal = id => {
    setCheckImportStore(!checkImportStore)
    setIsVisibleUpdateModal(true)
    setSelectedTemplateId(id)
  }
  const handleCancelUpdateModal = () => {
    setIsVisibleUpdateModal(false)
    setCheckImportStore(!checkImportStore)
  }

  const handleToggleCreateModal = bool => event => {
    setIsVisibleCreateModal(bool)
  }
  const handleTogglePreviewModal = bool => event => {
    setIsVisiblePreviewModal(bool)
    managementAssetWarehouseStore.setQueryParams('sizeIndex', 10)
  }

  const handleCancelImport = () => {
    setImportVisible(false)
    setFileExcel(null)
    managementAssetWarehouseStore.setQueryParams('sizeIndex', 10)
  }

  const normalizeString = str => {
    return str
      ?.normalize('NFD') // Tách chữ cái và dấu
      ?.replace(/[\u0300-\u036f]/g, '') // Xóa dấu
      ?.toLowerCase() // Chuyển về chữ thường
  }

  const propData = {
    beforeUpload: file => {
      const isXlsx =
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isXlsx) {
        message.error('Vui lòng tải lên tệp XLSX hợp lệ!')
      }
      return false
    },
    onChange: info => {
      if (info.fileList && info.fileList.length > 0) {
        let reader = new FileReader()
        reader.readAsBinaryString(
          info.fileList[info.fileList.length - 1].originFileObj
        )
        reader.onload = e => {
          let data = e.target.result
          let workbook = XLSX.read(data, { type: 'binary' })
          let first_sheet_name = workbook.SheetNames[0]
          let worksheet = workbook.Sheets[first_sheet_name]
          let rows = XLSX.utils.sheet_to_json(worksheet, {
            raw: false,
            header: 1,
            blankrows: true,
          })

          if (rows.length >= 5) {
            const groupedData = {}
            let currentGroup = null
            let currentGroupName = null
            // tách data thành các nhóm dựa vào ký tự đầu tiên của dòng
            rows.forEach(row => {
              // Nếu dòng là nhóm (dựa vào việc chỉ có 2 cột và ký tự đầu tiên là chữ cái)
              if (row.length === 2 && /^[A-Z]$/.test(row[0])) {
                currentGroup = row[0] // Gán mã nhóm (A, B, ...)
                currentGroupName = row[1] // Gán tên nhóm ("GIẤY CÁC LOẠI", ...)
                groupedData[currentGroup] = {
                  name: currentGroupName,
                  items: [],
                } // Khởi tạo nhóm mới
              } else if (currentGroup && row.length > 2) {
                // Thêm dữ liệu vào nhóm hiện tại
                groupedData[currentGroup].items.push(row)
              }
            })

            // Thay thế tên nhóm bằng id dựa theo danh sách loại văn phòng phẩm
            for (const item of managementAssetTypes) {
              const normalizedDescription = normalizeString(item.description)

              // Không biết nguyên nhân vì sao groupedDate lại có key là number
              for (const groupKey in groupedData) {
                if (typeof groupedData[groupKey]?.name === 'string') {
                  const normalizedGroupName = normalizeString(
                    groupedData[groupKey]?.name
                  )
                  if (normalizedDescription === normalizedGroupName) {
                    groupedData[groupKey].name = item.id // Thay thế name bằng id
                  }
                }
              }
            }

            const result = []
            const notFoundName = []
            // Duyệt qua các nhóm
            Object.keys(groupedData).forEach(groupKey => {
              const group = groupedData[groupKey]

              if (typeof group.name !== 'string') {
                const items = group.items
                // Duyệt qua các items trong nhóm
                items.forEach(item => {
                  const newItem = {
                    asset_name: item[1], // Tên (Giấy A4, Giấy A3, ...)
                    asset_unit_name: item[2], // Đơn vị (ram, cuộn, ...)
                    tax: item[3].replace('%', '').trim(), // Thuế (8%)
                    price: item[4].replace(/[^0-9.-]+/g, ''), // Đơn giá trước thuế (chuyển thành số, bỏ ký tự không phải số)
                    total_money: item[5].replace(/[^0-9.-]+/g, ''), // Đơn giá sau thuế (chuyển thành số, bỏ ký tự không phải số)
                    amount: item[6] ? item[6] : 0, // Số lượng (14, 10, ...)
                    asset_type_id: group.name, // Thêm trường 'type' là tên nhóm ("GIẤY CÁC LOẠI", ...)
                    property: null,
                  }
                  result.push(newItem) // Thêm item mới vào mảng kết quả
                })
              } else {
                notFoundName.push(group.name)
              }
            })
            if (notFoundName.length > 0) {
              message.error(
                `Không tìm thấy loại văn phòng phẩm: ${notFoundName.join(', ')}`
              )
            }
            setImportVisible(false)
            setIsVisiblePreviewModal(true)
            setListDataPreview(result)
          }
        }
      }
      return false
    },
  }

  const handleCreateListAssetWarehouse = async () => {
    try {
      setIsLoadingCreate(true)
      const result = listDataPreview.filter(
        preview =>
          !listDataCurrent.some(
            current => current.asset_name === preview.asset_name
          )
      )
      const res = await ManagementAssetWarehouseRequest.createManagementAssetListWarehouse(
        result
      )
      if (res.status === 200) {
        message.success(`${res.data}`)
        await managementAssetWarehouseStore.getManagementAssetWarehousetList(
          currentQueryString
        )
        setIsVisiblePreviewModal(false)
      }
    } catch (error) {
      console.error('Error creating asset list:', error)
      message.error('Đã xảy ra lỗi khi tạo mới tài sản.')
    } finally {
      setIsLoadingCreate(false)
    }
  }

  return (
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Hành chính | Quản lý kho | Tài sản</title>
        </Helmet>
        <AppPageHeader
          title="Quản lý tài sản VPP"
          addon={
            <>
              <ManagementAssetWarehousePageAdvanceFilterV2 />
              <AccessControlAction check={true}>
                <Button
                  title="Tạo mới tài sản từ file excel"
                  className="custom-ant-button icon-btn"
                  icon={<FileSendOutlineIcon style={{ width: 16, height: 16 }} />}
                  onClick={() => setImportVisible(true)}>
                  Import excel
                </Button>
                {selectedRowKeys?.length > 0 && (
                  <Button
                    className="custom-ant-button icon-btn"
                    icon={<Home2OutlineIcon style={{ width: 16, height: 16 }} />}
                    disabled={selectedRowKeys?.length > 0 ? false : true}
                    onClick={() => handleOpenUpdateModal(selectedRowKeys[0])}>
                    Nhập kho
                  </Button>
                )}

                <Button
                  title="Tải dữ liệu tài sản"
                  className="custom-ant-button icon-btn"
                  icon={
                    <FileDownloadOutlineIcon style={{ width: 16, height: 16 }} />
                  }
                  onClick={() => exportBetRefundExcel()}>
                  Export excel
                </Button>

                <Button
                  className="custom-ant-button icon-btn"
                  type={'primary'}
                  icon={
                    <AddCircleOutlineIcon
                      style={{ color: '#fff', width: 16, height: 16 }}
                    />
                  }
                  onClick={handleToggleCreateModal(true)}>
                  Tạo mới
                </Button>
              </AccessControlAction>
            </>
          }
        />

        <div>
          <Menu
            className="custom-menu-tab"
            mode="horizontal"
            selectedKeys={[props.location?.pathname]}
            style={{ marginBottom: 16 }}>
            <Menu.Item key="/manager-inventory/inventory-asset">
              <Link to={'/manager-inventory/inventory-asset'}>Tài sản</Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/manage-inventory-asset">
              <Link to={'/manager-inventory/manage-inventory-asset'}>
                Loại văn phòng phẩm
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/statistic">
              <Link to={'/manager-inventory/statistic'}>
                Thống kê tài sản tháng {currentDate}
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/export-statistic">
              <Link to={'/manager-inventory/export-statistic'}>
                Báo cáo sử dụng văn phòng phẩm theo tháng {currentDate}
              </Link>
            </Menu.Item>
          </Menu>

          <ManagementAssetWarehouseTable
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        </div>
      </DashboardLayout>
      <Modal
        width={700}
        title={'Tạo mới tài sản'}
        wrapClassName="custom-modal-wrapper"
        visible={isVisibleCreateModal}
        maskClosable={false}
        onCancel={handleToggleCreateModal(false)}
        footer={null}
        destroyOnClose>
        {isVisibleCreateModal && (
          <ManagementAssetWarehouseCreate
            onCancel={handleToggleCreateModal(false)}
          />
        )}
      </Modal>
      <Modal
        width={1200}
        wrapClassName="custom-modal-wrapper"
        title={'Xem trước tạo mới tài sản'}
        visible={isVisiblePreviewModal}
        maskClosable={false}
        onCancel={handleTogglePreviewModal(false)}
        footer={null}
        destroyOnClose>
        {isVisiblePreviewModal && (
          <>
            <ManagementAssetWarehousePreviewModal
              isLoadingCreate={isLoadingCreate}
              listDataPreview={listDataPreview}
              listDataCurrent={listDataCurrent}
              managementAssetTypes={managementAssetTypes}
              onCancel={handleTogglePreviewModal(false)}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                marginTop: 24,
              }}>
              <Button
                className="custom-ant-button"
                key="cancel"
                onClick={handleTogglePreviewModal(false)}>
                Đóng
              </Button>
              <Button
                className="custom-ant-button"
                loading={isLoadingCreate}
                key="create"
                type="primary"
                onClick={handleCreateListAssetWarehouse}>
                Tạo mới
              </Button>
            </div>
          </>
        )}
      </Modal>
      <Modal
        width={700}
        title={'Nhập kho'}
        visible={isVisibleUpdateModal}
        maskClosable={false}
        onCancel={handleCancelUpdateModal}
        footer={null}
        destroyOnClose>
        {isVisibleUpdateModal && (
          <ManagementAssetWarehouseUpdate
            onCancel={handleCancelUpdateModal}
            templateId={selectedTemplateId}
            checkImportStore={checkImportStore}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        )}
      </Modal>
      <Modal
        title="Nhập file excel"
        visible={importVisible}
        onCancel={handleCancelImport}
        wrapClassName="custom-modal-wrapper"
        footer={null}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
          }}>
          <Button
            danger
            ghost
            onClick={handleCancelImport}
            className="custom-ant-button">
            Hủy
          </Button>
          <Button className="custom-ant-button">
            <Link
              to={`/etc/Template.xlsx?date=${moment().format(
                'YYYY-MM-DD-HH-mm-ss'
              )}`}
              target="_blank"
              download
              style={{ textDecoration: 'none' }}>
              Tải file mẫu
            </Link>
          </Button>
          <Upload
            {...propData}
            showUploadList={false}
            accept={
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }>
            <Button
              className="custom-ant-button"
              icon={<FileExcelOutlined />}
              onClick={async () => {
                await managementAssetWarehouseStore.fetchManagementAssetTypeListv2(
                  `page=0&size=999999`
                )
                const result = await ManagementAssetWarehouseRequest.getManagementAssetWarehouseList(
                  `page=0&size=999999`
                )
                setListDataCurrent(result.data.data)
              }}>
              Import excel
            </Button>
          </Upload>
        </div>
      </Modal>

      {preViewVisible && (
        <ModalAssetPreView
          data={dataExcel}
          setPreViewVisible={setPreViewVisible}
          onCancel={() => setPreViewVisible(false)}
        />
      )}
    </WorkPageWrapper>
  )
}

export default inject(
  'managementAssetWarehouseStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'selectPeopleStore',
  'fileStore'
)(observer(ManagementAssetWarehousePage))
